function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import "./LeaveHistory.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import Button from "react-bootstrap/Button";
import { FilterContext, UserContext } from "../index";
import { HiDownload } from "react-icons/hi";
import Modal from "react-bootstrap/Modal";
import { GET_LEAVE_HISTORY_QUERY, USER_LEAVE_HISTORY_QUERY, USER_LEAVE_SUMMARY_EXPORT_QUERY, LEAVE_BALANCE_QUERY, LEAVE_BALANCE_EXPORT_QUERY, LIST_LEAVE_TYPE_QUERY, ADD_USER_LEAVE_TYPE_MUTATION, GET_SHORT_LEAVE_HISTORY_QUERY, USER_SHORT_LEAVE_HISTORY_QUERY, GET_EXPORT_SHORT_LEAVE_HISTORY_QUERY, EDIT_USER_LEAVE_BALANCE_AVAILABLE_MUTATION, EDIT_USER_LEAVE_BALANCE_DEFAULT_MUTATION } from "./query";
import Loader from "./../Loader/Loader";
import moment from "moment-timezone";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { GET_USER_LISTING_QUERY } from "./../AdminViewLeave/query";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import classNames from "classnames";
import Table from "react-bootstrap/Table";
import Popover from "react-bootstrap/Popover";
import { MdDateRange } from "react-icons/md";
import { stringToArrayOutput } from "./../SideMenu/Header.js";
import Badge from "react-bootstrap/Badge";
import { Field, Form as FormikForm, Formik } from "formik";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import { toast } from "react-toastify";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { MdInfoOutline } from "react-icons/md";
import { decodeHtmlEntities, isRateLimited, rateLimitMessage } from "../utils";
import { LEAVE_SETTINGS_APPROVED_LIST_QUERY } from "./../LeaveSettings/query";
import ProgressBar from "react-bootstrap/ProgressBar";
import * as Yup from "yup";
import { LeaveManagementEnableFeature } from "./../AdminViewLeave/AdminViewLeave";
var LIMIT = 15;
var offsets = 0;
var USER_LEAVE_LIMIT = 15;
var leave_offsets = 0;
var LeaveHistory = function LeaveHistory(props) {
  var _leaveSettingsApprove, _leaveSettingsApprove2, _leaveSettingsApprove3, _userListData$getUser, _leaveSettingsApprove6, _leaveBalanceData$get5, _leaveBalanceData$get6, _leaveBalanceData$get7;
  var _React$useState = React.useState("leave-summary"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    tabData = _React$useState2[0],
    setTabData = _React$useState2[1];
  var _React$useState3 = React.useState({
      label: "All Members",
      value: null
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    userParameterCheck = _React$useState4[0],
    setUserParameterCheck = _React$useState4[1];
  var _React$useState5 = React.useState(new Date()),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    leaveYear = _React$useState6[0],
    setLeaveYear = _React$useState6[1];

  // console.log({ leaveYear });

  var _React$useState7 = React.useState(new Date()),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    leaveBalanceStartDate = _React$useState8[0],
    setLeaveBalanceStartDate = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    leaveBalanceEndDate = _React$useState10[0],
    setLeaveBalanceEndDate = _React$useState10[1];
  var _React$useState11 = React.useState(moment(startDate).startOf("month").toDate()),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    shortLeaveStartDate = _React$useState12[0],
    setShortLeaveStartDate = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    shortLeaveEndDate = _React$useState14[0],
    setShortLeaveEndDate = _React$useState14[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    viewLeaveShow = _useState2[0],
    setViewLeaveShow = _useState2[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    exportButton = _React$useState16[0],
    setExportButton = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isAllLoadedLeaveBalance = _React$useState18[0],
    setIsAllLoadedLeaveBalance = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isLoadingMoreLeaveBalance = _React$useState20[0],
    setIsLoadingMoreLeaveBalance = _React$useState20[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    viewShortLeaveShow = _useState4[0],
    setViewShortLeaveShow = _useState4[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    organisationBilling = _React$useContext.organisationBilling,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    role = _React$useContext.role,
    from = _React$useContext.from,
    leaveSettingsUser = _React$useContext.leaveSettingsUser,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    startTime = _useState6[0],
    setStartTime = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    endTime = _useState8[0],
    setEndTime = _useState8[1];
  var handleViewLeaveClose = function handleViewLeaveClose() {
    return setViewLeaveShow(false);
  };
  var handleViewLeaveShow = function handleViewLeaveShow(list) {
    return setViewLeaveShow(list);
  };
  var handleViewShortLeaveClose = function handleViewShortLeaveClose() {
    return setViewShortLeaveShow(false);
  };
  var handleViewShortLeaveShow = function handleViewShortLeaveShow(list) {
    return setViewShortLeaveShow(list);
  };
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    shortExportButton = _React$useState22[0],
    setShortExportButton = _React$useState22[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var _React$useState23 = React.useState({
      label: "Apr ".concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().format("YYYY") : moment().add(1, "year").format("YYYY")),
      value: "".concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().format("YYYY"))
    }),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    financialCheck = _React$useState24[0],
    setFinancialCheck = _React$useState24[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    yearFormatExport = _useState10[0],
    setYearFormatExport = _useState10[1];
  var leaveSettingsCheckForUser = leaveSettingsUser && leaveSettingsUser !== null && leaveSettingsUser !== void 0 && leaveSettingsUser.approvedList.length ? leaveSettingsUser === null || leaveSettingsUser === void 0 ? void 0 : leaveSettingsUser.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  React.useEffect(function () {
    if (from == "web" && (role == "Member" || role == "Head") && !leaveSettingsCheckForUser && role != "Admin") {
      if (role == "Member") {
        props === null || props === void 0 ? void 0 : props.history.push("/my-work");
      }
      if (role == "Head") {
        props === null || props === void 0 ? void 0 : props.history.push("/overview");
      }
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free") {
    return /*#__PURE__*/React.createElement(PlanUpdateMsgForAdmin, {
      organisationBilling: organisationBilling,
      user: user,
      history: props === null || props === void 0 ? void 0 : props.history
    });
  }
  var _useQuery = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free"
    }),
    userListLoading = _useQuery.loading,
    userListData = _useQuery.data,
    userListError = _useQuery.error,
    userListRefetch = _useQuery.refetch;
  function convertOrganisationTimezone(sD, tz) {
    var currentSystemTimezone = moment.tz.guess();
    var startTime = moment(sD).tz(tz).format("YYYY-MM-DD HH:mm:ss");
    var endTime = moment(sD).tz(tz).format("YYYY-MM-DD HH:mm:ss");
    var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
    var zoneoffset = moment.tz(tz).utcOffset();
    if (zoneoffset !== currentSystemOffset) {
      var zoneoffsetTemp = Math.abs(zoneoffset);
      var currentSystemOffsetTemp = Math.abs(currentSystemOffset);
      if (zoneoffset > 0) {
        zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
      } else {
        zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
      }
    }
    var startTimeFullFormat = moment(startTime).tz(currentSystemTimezone).startOf("year").format("YYYY-MM-DD HH:mm:ss");
    var endTimeFullFormat = moment(endTime).tz(currentSystemTimezone).endOf("year").format("YYYY-MM-DD HH:mm:ss");
    var startTimeYear = moment(startTime).tz(currentSystemTimezone).startOf("year").format("YYY");
    if (zoneoffset >= 0) {
      startTimeFullFormat = moment(startTime).startOf("year").format("YYYY-MM-DD HH:mm:ss");
      endTimeFullFormat = moment(endTime).endOf("year").format("YYYY-MM-DD HH:mm:ss");
      startTimeYear = moment(startTime).startOf("year").format("YYYY");
      if (zoneoffset !== currentSystemOffset && zoneoffset < currentSystemOffset) {
        startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY-MM-DD HH:mm:ss");
        endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("year").format("YYYY-MM-DD HH:mm:ss");
        startTimeYear = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY");
      } else if (zoneoffset > currentSystemOffset) {
        startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY-MM-DD HH:mm:ss");
        endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("year").format("YYYY-MM-DD HH:mm:ss");
        startTimeYear = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY");
      }
    } else {
      zoneoffset = Math.abs(zoneoffset);
      startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY-MM-DD HH:mm:ss");
      endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("year").format("YYYY-MM-DD HH:mm:ss");
      startTimeYear = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY");
    }
    return {
      startTimeFullFormat: startTimeFullFormat,
      endTimeFullFormat: endTimeFullFormat,
      startTimeYear: startTimeYear
    };
  }
  React.useEffect(function () {
    var _convertOrganisationT = convertOrganisationTimezone(leaveYear, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone),
      startTimeFullFormat = _convertOrganisationT.startTimeFullFormat,
      endTimeFullFormat = _convertOrganisationT.endTimeFullFormat,
      startTimeYear = _convertOrganisationT.startTimeYear;
    setStartTime(startTimeFullFormat);
    setEndTime(endTimeFullFormat);
    setYearFormatExport(startTimeYear);
  }, [leaveYear]);

  // NOTE: "HH" (24-hour), not "hh" (12-hour) - "hh" rendered midnight as
  // "12:00" and 23:59:59 as "11:59", shifting the financial-year boundaries
  // by 12 hours and silently dropping leave dated on the boundary day.
  var leaveStartTime = moment("Apr", "MMM").year(financialCheck.value).startOf("month").format("YYYY-MM-DD HH:mm:ss");
  var leaveEndTime = moment("Mar", "MMM").year(financialCheck.value).add(1, "year").endOf("month").format("YYYY-MM-DD HH:mm:ss");
  var _useQuery2 = useQuery(LEAVE_SETTINGS_APPROVED_LIST_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    leaveSettingsApprovedLoading = _useQuery2.loading,
    leaveSettingsApprovedData = _useQuery2.data,
    leaveSettingsApprovedError = _useQuery2.error;
  var _useQuery3 = useQuery(GET_LEAVE_HISTORY_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        leaveYearStartTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove === void 0 ? void 0 : _leaveSettingsApprove.leaveYearSettings) !== "financial-year" ? startTime : leaveStartTime,
        leaveYearEndTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove2 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove2 === void 0 ? void 0 : _leaveSettingsApprove2.leaveYearSettings) !== "financial-year" ? endTime : leaveEndTime,
        teamId: teamId,
        userRole: role
      },
      // cache-and-network (not the default cache-first): this component
      // remounts on every navigation back to /leave-summary (it's a separate
      // route from /apply-leave, not a tab within one page), re-issuing this
      // query with the same variables. cache-first would then serve the stale
      // cached counts from before a leave was applied, only fixed by a full
      // page reload that throws away the Apollo cache. cache-and-network shows
      // the cached data instantly but always follows up with a real fetch.
      fetchPolicy: "cache-and-network",
      // Wait for the leave-year settings to load before firing this query, and -
      // for the calendar-year case - wait for startTime/endTime to be computed.
      // Without this, the query fires once with null dates, again once
      // startTime/endTime are set (calendar-year variables), and a third time
      // once leaveSettingsApprovedData resolves to "financial-year" - 3 network
      // calls for organisations on a financial leave year.
      skip: !organisationId || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" || leaveSettingsApprovedLoading || (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove3 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove3 === void 0 ? void 0 : _leaveSettingsApprove3.leaveYearSettings) !== "financial-year" && (!startTime || !endTime)
    }),
    leaveHistoryData = _useQuery3.data,
    leaveHistoryError = _useQuery3.error,
    leaveHistoryLoading = _useQuery3.loading,
    leaveHistoryFetchMore = _useQuery3.fetchMore,
    leaveHistoryRefetch = _useQuery3.refetch;
  var _useLazyQuery = useLazyQuery(USER_LEAVE_HISTORY_QUERY, {
      fetchPolicy: "network-only",
      // Without this, every fetchMore() (Load more) is followed by an extra,
      // unwanted network call replaying the original offset: 0 variables -
      // network-only forces the base watched query to distrust the cache even
      // when Apollo re-broadcasts it the merged data fetchMore's updateQuery
      // just wrote. nextFetchPolicy keeps network-only for the initial fetch
      // (so opening the modal always gets fresh data) but lets every
      // subsequent notification - including fetchMore's - read from the cache.
      nextFetchPolicy: "cache-first"
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getUserLeaveHistory = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    userLeaveHistoryLoading = _useLazyQuery2$.loading,
    userLeaveHistoryData = _useLazyQuery2$.data,
    userLeaveHistoryError = _useLazyQuery2$.error,
    userLeaveHistoryFetchMore = _useLazyQuery2$.fetchMore;
  var _useLazyQuery3 = useLazyQuery(USER_SHORT_LEAVE_HISTORY_QUERY, {
      fetchPolicy: "network-only",
      // See getUserLeaveHistory above - same network-only + fetchMore duplicate-call issue.
      nextFetchPolicy: "cache-first"
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getUserShortLeaveHistory = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    userShortLeaveHistoryLoading = _useLazyQuery4$.loading,
    userShortLeaveHistoryData = _useLazyQuery4$.data,
    userShortLeaveHistoryError = _useLazyQuery4$.error,
    userShortLeaveHistoryFetchMore = _useLazyQuery4$.fetchMore,
    userShortLeaveHistoryRefetch = _useLazyQuery4$.refetch;
  var _useLazyQuery5 = useLazyQuery(GET_SHORT_LEAVE_HISTORY_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        startTime: Number(shortLeaveStartDate),
        endTime: shortLeaveEndDate ? Number(shortLeaveEndDate) : Number(shortLeaveStartDate)
      },
      fetchPolicy: "network-only",
      skip: !organisationId || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free"
    }),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getShortLeaveSummaryBalance = _useLazyQuery6[0],
    _useLazyQuery6$ = _useLazyQuery6[1],
    shortLeaveHistoryLoading = _useLazyQuery6$.loading,
    shortLeaveHistoryData = _useLazyQuery6$.data,
    shortLeaveHistoryError = _useLazyQuery6$.error,
    shortLeaveFetchMore = _useLazyQuery6$.fetchMore,
    shortLeaveHistoryRefetch = _useLazyQuery6$.refetch;
  var _useLazyQuery7 = useLazyQuery(LEAVE_BALANCE_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
        startTime: Number(leaveBalanceStartDate),
        endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        userRole: role
      },
      skip: !organisationId
    }),
    _useLazyQuery8 = _slicedToArray(_useLazyQuery7, 2),
    getLeaveSummaryBalance = _useLazyQuery8[0],
    _useLazyQuery8$ = _useLazyQuery8[1],
    leaveBalanceLoading = _useLazyQuery8$.loading,
    leaveBalanceData = _useLazyQuery8$.data,
    leaveBalanceError = _useLazyQuery8$.error,
    leaveBalanceFetchMore = _useLazyQuery8$.fetchMore,
    leaveBalanceRefetch = _useLazyQuery8$.refetch;
  var userList = [{
    label: "All Members",
    value: null
  }];
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListingForLeave) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });

  //dynamic finacial year generation
  var financialYearList = [{
    label: "Apr ".concat(moment().format("M") <= 3 ? moment().subtract(3, "year").format("YYYY") : moment().subtract(2, "year").format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().subtract(2, "year").format("YYYY") : moment().subtract(1, "year").format("YYYY")),
    value: "".concat(moment().format("M") <= 3 ? moment().subtract(3, "year").format("YYYY") : moment().subtract(2, "year").format("YYYY"))
  }, {
    label: "Apr ".concat(moment().format("M") <= 3 ? moment().subtract(2, "year").format("YYYY") : moment().subtract(1, "year").format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().subtract(0, "year").format("YYYY")),
    value: "".concat(moment().format("M") <= 3 ? moment().subtract(2, "year").format("YYYY") : moment().subtract(1, "year").format("YYYY"))
  }, {
    label: "Apr ".concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().format("YYYY") : moment().add(1, "year").format("YYYY")),
    value: "".concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().format("YYYY"))
  }, {
    label: "Apr ".concat(moment().format("M") <= 3 ? moment().format("YYYY") : moment().add(1, "year").format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().add(1, "year").format("YYYY") : moment().add(2, "year").format("YYYY")),
    value: "".concat(moment().format("M") <= 3 ? moment().format("YYYY") : moment().add(1, "year").format("YYYY"))
  }];
  var _useLazyQuery9 = useLazyQuery(USER_LEAVE_SUMMARY_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
        setShortExportButton(false);
      }
    }),
    _useLazyQuery10 = _slicedToArray(_useLazyQuery9, 2),
    getLeaveSummaryExport = _useLazyQuery10[0],
    _useLazyQuery10$ = _useLazyQuery10[1],
    leaveSummaryExportLoading = _useLazyQuery10$.loading,
    leaveSummaryExportData = _useLazyQuery10$.data;
  var _useLazyQuery11 = useLazyQuery(GET_EXPORT_SHORT_LEAVE_HISTORY_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
        setShortExportButton(false);
      }
    }),
    _useLazyQuery12 = _slicedToArray(_useLazyQuery11, 2),
    getShortLeaveSummaryExport = _useLazyQuery12[0],
    _useLazyQuery12$ = _useLazyQuery12[1],
    shortLeaveSummaryExportLoading = _useLazyQuery12$.loading,
    shortLeaveSummaryExportData = _useLazyQuery12$.data;
  var _useLazyQuery13 = useLazyQuery(LEAVE_BALANCE_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
        setShortExportButton(false);
      }
    }),
    _useLazyQuery14 = _slicedToArray(_useLazyQuery13, 2),
    getExport = _useLazyQuery14[0],
    _useLazyQuery14$ = _useLazyQuery14[1],
    exportLoading = _useLazyQuery14$.loading,
    exportData = _useLazyQuery14$.data;
  var getExportData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _leaveSettingsApprove4, _leaveSettingsApprove5;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setExportButton(true);
            getLeaveSummaryExport({
              variables: {
                organisationId: organisationId,
                userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                // leaveYearStartTime: startTime,
                // leaveYearEndTime: endTime,
                leaveYearStartTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove4 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove4 === void 0 ? void 0 : _leaveSettingsApprove4.leaveYearSettings) !== "financial-year" ? startTime : leaveStartTime,
                leaveYearEndTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove5 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove5 === void 0 ? void 0 : _leaveSettingsApprove5.leaveYearSettings) !== "financial-year" ? endTime : leaveEndTime,
                teamId: teamId,
                userRole: role
              }
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getExportData() {
      return _ref.apply(this, arguments);
    };
  }();
  var getShortLeaveExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setShortExportButton(true);
            getShortLeaveSummaryExport({
              variables: {
                organisationId: organisationId,
                userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                startTime: Number(shortLeaveStartDate),
                endTime: shortLeaveEndDate ? Number(shortLeaveEndDate) : Number(shortLeaveStartDate)
              }
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getShortLeaveExportData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var csvLeaveData = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(leaveYear) {
      var dataArray, dataValues, wb, ws, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dataArray = [];
            dataValues = leaveSummaryExportData === null || leaveSummaryExportData === void 0 ? void 0 : leaveSummaryExportData.userLeaveSummaryExport;
            if (dataValues) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return", []);
          case 4:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            ws.columns = [{
              header: "Employee Name",
              key: "user",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Year",
              key: "year",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Applied Leave",
              key: "appliedLeave",
              width: 10,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Approved Leave",
              key: "approvedLeave",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Approval Pending",
              key: "pendingApproval",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Rejected Leave",
              key: "rejectedLeave",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            dataValues.map(function (d, index) {
              var appliedLeave = d.appliedLeave,
                approvedLeave = d.approvedLeave,
                pendingLeave = d.pendingLeave,
                rejectedLeave = d.rejectedLeave,
                user = d.user;
              var displayName = user.displayName;
              appliedLeave = appliedLeave ? appliedLeave : 0;
              approvedLeave = approvedLeave ? approvedLeave : 0;
              pendingLeave = pendingLeave ? pendingLeave : 0;
              rejectedLeave = rejectedLeave ? rejectedLeave : 0;
              ws.addRow({
                user: displayName,
                year: leaveYear ? yearFormatExport : "",
                appliedLeave: Number(appliedLeave) > 1 ? "".concat(appliedLeave, " Days") : "".concat(appliedLeave, " Day"),
                approvedLeave: Number(approvedLeave) > 1 ? "".concat(approvedLeave, " Days") : "".concat(approvedLeave, " Day"),
                pendingApproval: Number(pendingLeave) > 1 ? "".concat(pendingLeave, " Days") : "".concat(pendingLeave, " Day"),
                rejectedLeave: Number(rejectedLeave) > 1 ? "".concat(rejectedLeave, " Days") : "".concat(rejectedLeave, " Day")
              });
            });
            ws.getCell("A1").font = {
              bold: true
            };
            ws.getCell("B1").font = {
              bold: true
            };
            ws.getCell("C1").font = {
              bold: true
            };
            ws.getCell("D1").font = {
              bold: true
            };
            ws.getCell("E1").font = {
              bold: true
            };
            ws.getCell("F1").font = {
              bold: true
            };
            _context3.next = 16;
            return wb.xlsx.writeBuffer();
          case 16:
            buf = _context3.sent;
            fileName = "workfolio-leave-summary-".concat(leaveYear ? moment(leaveYear).format("yyyy") : "", ".xlsx");
            saveAs(new Blob([buf]), fileName);
            setExportButton(false);
          case 20:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [leaveSummaryExportData]);
  var csvData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _dataValues$;
    var dataValues, wb, ws, col, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.getLeaveSummaryBalanceExport;
          if (dataValues) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          col = [{
            header: "Employee",
            key: "employee",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          (_dataValues$ = dataValues[0]) === null || _dataValues$ === void 0 ? void 0 : _dataValues$.date.map(function (dTemp) {
            var dateValue = dTemp.dateValue,
              clockIn = dTemp.clockIn,
              clockOut = dTemp.clockOut;
            var inHeader = "".concat(dateValue, " (Available)");
            var outHeader = "".concat(dateValue, " (Booked)");
            var carryForwardHeader = "".concat(dateValue, " (Carry Forward Count)");
            var leaveCountHeader = "".concat(dateValue, " (Leave Count)");
            col.push({
              header: carryForwardHeader,
              key: carryForwardHeader,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
            col.push({
              header: leaveCountHeader,
              key: leaveCountHeader,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
            col.push({
              header: inHeader,
              key: inHeader,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
            col.push({
              header: outHeader,
              key: outHeader,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
          });
          col.push({
            header: "Total Leave Taken",
            key: "totalLeave",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          });
          ws.columns = col;
          dataValues.map(function (user, index) {
            var date = user.date,
              employee = user.employee,
              totalLeave = user.totalLeave;
            var typeTableData = {};
            date.map(function (dTemp) {
              var dateValue = dTemp.dateValue,
                available = dTemp.available,
                booked = dTemp.booked,
                carryForwardCount = dTemp.carryForwardCount,
                leaveCount = dTemp.leaveCount;
              var inHeader = "".concat(dateValue, " (Available)");
              var outHeader = "".concat(dateValue, " (Booked)");
              var carryForward = "".concat(dateValue, " (Carry Forward Count)");
              var leaveCounts = "".concat(dateValue, " (Leave Count)");
              typeTableData = _objectSpread(_objectSpread({}, typeTableData), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, inHeader, available), outHeader, booked), carryForward, carryForwardCount), leaveCounts, leaveCount));
            });
            ws.addRow(_objectSpread({
              employee: employee,
              totalLeave: totalLeave
            }, typeTableData));
          });
          ws.getRow(1).font = {
            bold: true
          };
          _context4.next = 13;
          return wb.xlsx.writeBuffer();
        case 13:
          buf = _context4.sent;
          //const fileName = `workfolio-user-leave-balance-${moment(leaveStartTime).format("MMMM yyyy")}.xlsx`;
          fileName = "workfolio-user-leave-balance-".concat(moment(Number(leaveBalanceStartDate)).format("DD-MMM"), ".xlsx");
          if (leaveBalanceEndDate != null) {
            fileName = "workfolio-user-leave-balance-".concat(moment(Number(leaveBalanceStartDate)).format("DD-MMM"), "-").concat(moment(Number(leaveBalanceEndDate)).format("DD-MMM"), ".xlsx");
          }
          saveAs(new Blob([buf]), fileName);
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [exportData]);
  var csvShortLeaveData = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(shortLeaveStartDate, shortLeaveEndDate) {
      var dataArray, dataValues, wb, ws, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dataArray = [];
            dataValues = shortLeaveSummaryExportData === null || shortLeaveSummaryExportData === void 0 ? void 0 : shortLeaveSummaryExportData.getExportShortleaveHistory; //console.log({dataValues})
            if (dataValues) {
              _context5.next = 4;
              break;
            }
            return _context5.abrupt("return", []);
          case 4:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            ws.columns = [{
              header: "Employee Name",
              key: "user",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Month",
              key: "year",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Applied Short Leave",
              key: "appliedShortLeave",
              width: 10,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Approved Short Leave",
              key: "approvedShortLeave",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Approval Short Pending",
              key: "pendingShortLeave",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Rejected Short Leave",
              key: "rejectedShortLeave",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            dataValues.map(function (d, index) {
              var appliedShortLeave = d.appliedShortLeave,
                approvedShortLeave = d.approvedShortLeave,
                pendingShortLeave = d.pendingShortLeave,
                rejectedShortLeave = d.rejectedShortLeave,
                user = d.user;
              var displayName = user.displayName;
              appliedShortLeave = appliedShortLeave ? appliedShortLeave : 0;
              approvedShortLeave = approvedShortLeave ? approvedShortLeave : 0;
              pendingShortLeave = pendingShortLeave ? pendingShortLeave : 0;
              rejectedShortLeave = rejectedShortLeave ? rejectedShortLeave : 0;
              var year = "".concat(moment(Number(shortLeaveStartDate)).format("DD-MMM"));
              if (shortLeaveEndDate != null) {
                year = "".concat(moment(Number(shortLeaveStartDate)).format("DD-MMM"), "-").concat(moment(Number(shortLeaveEndDate)).format("DD-MMM"));
              }
              ws.addRow({
                user: displayName,
                year: year,
                appliedShortLeave: appliedShortLeave,
                approvedShortLeave: approvedShortLeave,
                pendingShortLeave: pendingShortLeave,
                rejectedShortLeave: rejectedShortLeave
              });
            });
            ws.getCell("A1").font = {
              bold: true
            };
            ws.getCell("B1").font = {
              bold: true
            };
            ws.getCell("C1").font = {
              bold: true
            };
            ws.getCell("D1").font = {
              bold: true
            };
            ws.getCell("E1").font = {
              bold: true
            };
            ws.getCell("F1").font = {
              bold: true
            };
            _context5.next = 16;
            return wb.xlsx.writeBuffer();
          case 16:
            buf = _context5.sent;
            fileName = "workfolio-short-leave-summary-".concat(moment(Number(shortLeaveStartDate)).format("DD-MMM"), ".xlsx");
            if (shortLeaveEndDate != null) {
              fileName = "workfolio-short-leave-summary-".concat(moment(Number(shortLeaveStartDate)).format("DD-MMM"), "-").concat(moment(Number(shortLeaveEndDate)).format("DD-MMM"), ".xlsx");
            }
            saveAs(new Blob([buf]), fileName);
            setShortExportButton(false);
          case 21:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }(), [shortLeaveSummaryExportData]);
  React.useEffect(function () {}, [leaveSettingsApprovedData]);
  React.useEffect(function () {
    csvLeaveData(leaveYear);
  }, [leaveSummaryExportData]);
  React.useEffect(function () {
    csvShortLeaveData(shortLeaveStartDate, shortLeaveEndDate);
  }, [shortLeaveSummaryExportData]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);
  var isLeaveHistoryMountRef = React.useRef(true);
  React.useEffect(function () {
    // Skip the initial mount - the queries above already fetch themselves on
    // mount (once their own variables/skip are ready). Calling refetch() here
    // on mount bypasses `skip` and fires a network request early, with
    // leaveYearStartTime/leaveYearEndTime still null. Only refetch on actual
    // subsequent navigations to this page.
    if (isLeaveHistoryMountRef.current) {
      isLeaveHistoryMountRef.current = false;
      return;
    }
    leaveHistoryRefetch === null || leaveHistoryRefetch === void 0 ? void 0 : leaveHistoryRefetch();
    userListRefetch === null || userListRefetch === void 0 ? void 0 : userListRefetch();
    leaveBalanceRefetch === null || leaveBalanceRefetch === void 0 ? void 0 : leaveBalanceRefetch();
    shortLeaveHistoryRefetch === null || shortLeaveHistoryRefetch === void 0 ? void 0 : shortLeaveHistoryRefetch();
    userShortLeaveHistoryRefetch === null || userShortLeaveHistoryRefetch === void 0 ? void 0 : userShortLeaveHistoryRefetch();
  }, [props.location.key]);
  React.useEffect(function () {
    if (tabData == "leave-balance") {
      getLeaveSummaryBalance();
    } else if (tabData == "short-leave-summary") {
      getShortLeaveSummaryBalance();
    }
  }, [tabData]);
  React.useEffect(function () {
    var _leaveBalanceData$get, _leaveBalanceData$get2, _leaveBalanceData$get3, _leaveBalanceData$get4;
    if ((leaveBalanceData === null || leaveBalanceData === void 0 ? void 0 : (_leaveBalanceData$get = leaveBalanceData.getLeaveSummaryBalance) === null || _leaveBalanceData$get === void 0 ? void 0 : (_leaveBalanceData$get2 = _leaveBalanceData$get.userData) === null || _leaveBalanceData$get2 === void 0 ? void 0 : _leaveBalanceData$get2.length) !== 0 && (leaveBalanceData === null || leaveBalanceData === void 0 ? void 0 : (_leaveBalanceData$get3 = leaveBalanceData.getLeaveSummaryBalance) === null || _leaveBalanceData$get3 === void 0 ? void 0 : (_leaveBalanceData$get4 = _leaveBalanceData$get3.userData) === null || _leaveBalanceData$get4 === void 0 ? void 0 : _leaveBalanceData$get4.length) < LIMIT && !isAllLoadedLeaveBalance) {
      setIsAllLoadedLeaveBalance(true);
    }
  }, [leaveBalanceData === null || leaveBalanceData === void 0 ? void 0 : leaveBalanceData.getLeaveSummaryBalance]);
  var handleTabSelect = function handleTabSelect(key) {
    setTabData(key);
  };

  // const handleChange = (e) => {
  //   setLeaveBalanceStartDate(e[0]);
  //   setLeaveBalanceEndDate(e[1]);
  // };

  var getBalanceExportData = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
                startTime: Number(leaveBalanceStartDate),
                endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                userRole: role
              }
            });
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function getBalanceExportData() {
      return _ref6.apply(this, arguments);
    };
  }();
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };

  //console.log({financialCheck,leaveStartTime});

  return /*#__PURE__*/React.createElement("div", null, !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined ? /*#__PURE__*/React.createElement(LeaveManagementEnableFeature, {
    displayName: user === null || user === void 0 ? void 0 : user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history,
    role: role
  }) : /*#__PURE__*/React.createElement("div", {
    className: "leave-history-tab-whole-div"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "leave-summary",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    },
    className: "leave-history-tab-leave-root-tab"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "leave-summary",
    title: /*#__PURE__*/React.createElement("span", null, "Leave Summary")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-new-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userList,
    className: "leave-history-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User",
    placeholder: "Select Employee",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "leave-history-date-picker"
  }, " ", (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove6 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove6 === void 0 ? void 0 : _leaveSettingsApprove6.leaveYearSettings) !== "financial-year" ? /*#__PURE__*/React.createElement(DatePicker, {
    selected: leaveYear,
    onChange: function onChange(date) {
      return setLeaveYear(date);
    },
    showYearPicker: true,
    dateFormat: "yyyy"
    // minDate={organisationBilling?.planName == "free" ? subDays(new Date(), 14) : null}
  }) : /*#__PURE__*/React.createElement("div", {
    className: "leave-history-date-picker-finacial"
  }, /*#__PURE__*/React.createElement(Select, {
    value: financialCheck,
    onChange: function onChange(e) {
      return setFinancialCheck(e);
    },
    options: financialYearList,
    className: "leave-history-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User",
    placeholder: "Select Year",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    }
  })))), /*#__PURE__*/React.createElement("div", null, !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    },
    className: "leave-history-filter-download-icon-btn"
  }, " ", /*#__PURE__*/React.createElement(HiDownload, {
    className: "leave-history-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    },
    className: "leave-history-filter-download-icon-btn"
  }, " ", /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading"))), /*#__PURE__*/React.createElement(LeaveHistoryTable, {
    columns: columns,
    handleViewLeaveShow: handleViewLeaveShow,
    leaveHistoryLoading: leaveHistoryLoading,
    leaveHistoryData: leaveHistoryData,
    leaveHistoryError: leaveHistoryError,
    leaveHistoryFetchMore: leaveHistoryFetchMore
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "short-leave-summary",
    title: /*#__PURE__*/React.createElement("span", null, "Short Leave Summary")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-new-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userList,
    className: "leave-history-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User",
    placeholder: "Select Employee",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "leave-history-date-picker"
  }, " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(ShortLeaveTimeFilter, {
      onClose: hideOverlay,
      shortLeaveStartDate: shortLeaveStartDate,
      setShortLeaveStartDate: setShortLeaveStartDate,
      shortLeaveEndDate: shortLeaveEndDate,
      setShortLeaveEndDate: setShortLeaveEndDate,
      organisationBilling: organisationBilling
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter",
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date summary-leave-balanace-modal-body-wrapper-form-div-field-input"
  }, /*#__PURE__*/React.createElement(MdDateRange, {
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date-icon"
  }), shortLeaveStartDate && shortLeaveEndDate ? /*#__PURE__*/React.createElement("p", {
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date-text"
  }, arrayToStringOutput([Number(shortLeaveStartDate), Number(shortLeaveEndDate)], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) : shortLeaveStartDate ? /*#__PURE__*/React.createElement("p", {
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date-text"
  }, arrayToStringOutput([Number(shortLeaveStartDate), Number(shortLeaveStartDate)], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) : /*#__PURE__*/React.createElement("p", {
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date-text"
  }, "Select Date"))))), /*#__PURE__*/React.createElement("div", null, !shortExportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getShortLeaveExportData();
    },
    className: "leave-history-filter-download-icon-btn"
  }, " ", /*#__PURE__*/React.createElement(HiDownload, {
    className: "leave-history-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "leave-history-filter-download-icon-btn"
  }, " ", /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading"))), /*#__PURE__*/React.createElement(ShortLeaveHistoryTable, {
    columns: shortLeavecolumns,
    handleViewLeaveShow: handleViewShortLeaveShow,
    leaveHistoryLoading: shortLeaveHistoryLoading,
    leaveHistoryData: shortLeaveHistoryData,
    leaveHistoryError: shortLeaveHistoryError
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "leave-balance",
    title: /*#__PURE__*/React.createElement("span", null, "View & Edit Leave Balance ", /*#__PURE__*/React.createElement("sup", {
      className: "page-content-wrapper-header-name-sup-leave"
    }, "Beta"))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-new-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userList,
    className: "leave-history-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User",
    placeholder: "Select Employee",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "leave-history-date-picker"
  }, " ", /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(TimeFilter, {
      onClose: hideOverlay
      // setFilterData={setFilterData}
      // setDateRange={setDateRange}
      // startDate={startDate}
      // endDate={endDate}
      ,

      leaveBalanceStartDate: leaveBalanceStartDate,
      setLeaveBalanceStartDate: setLeaveBalanceStartDate,
      leaveBalanceEndDate: leaveBalanceEndDate,
      setLeaveBalanceEndDate: setLeaveBalanceEndDate,
      organisationBilling: organisationBilling
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter",
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date summary-leave-balanace-modal-body-wrapper-form-div-field-input"
  }, /*#__PURE__*/React.createElement(MdDateRange, {
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date-icon"
  }), leaveBalanceStartDate && leaveBalanceEndDate ? /*#__PURE__*/React.createElement("p", {
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date-text"
  }, arrayToStringOutput([Number(leaveBalanceStartDate), Number(leaveBalanceEndDate)], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) : leaveBalanceStartDate ? /*#__PURE__*/React.createElement("p", {
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date-text"
  }, arrayToStringOutput([Number(leaveBalanceStartDate), Number(leaveBalanceStartDate)], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)) : /*#__PURE__*/React.createElement("p", {
    className: "summary-leave-balanace-modal-body-wrapper-form-date-picker-filter-date-text"
  }, "Select Date"))))), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      return getBalanceExportData();
    }
  }, " ", exportLoading ? "Downloading" : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiDownload, {
    className: "monthly-attendence-download-icon"
  }), " Export")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export")))), leaveBalanceLoading ? /*#__PURE__*/React.createElement(Loader, null) : leaveBalanceError ? /*#__PURE__*/React.createElement("div", null, "Something went wrong") : leaveBalanceData !== null && leaveBalanceData !== void 0 && (_leaveBalanceData$get5 = leaveBalanceData.getLeaveSummaryBalance) !== null && _leaveBalanceData$get5 !== void 0 && _leaveBalanceData$get5.userData ? /*#__PURE__*/React.createElement(LeaveBalance, {
    gridData: leaveBalanceData === null || leaveBalanceData === void 0 ? void 0 : (_leaveBalanceData$get6 = leaveBalanceData.getLeaveSummaryBalance) === null || _leaveBalanceData$get6 === void 0 ? void 0 : _leaveBalanceData$get6.userData,
    headers: leaveBalanceData === null || leaveBalanceData === void 0 ? void 0 : (_leaveBalanceData$get7 = leaveBalanceData.getLeaveSummaryBalance) === null || _leaveBalanceData$get7 === void 0 ? void 0 : _leaveBalanceData$get7.headerData,
    leaveBalanceFetchMore: leaveBalanceFetchMore,
    leaveBalanceLoading: leaveBalanceLoading,
    isAllLoadedLeaveBalance: isAllLoadedLeaveBalance,
    setIsAllLoadedLeaveBalance: setIsAllLoadedLeaveBalance,
    isLoadingMoreLeaveBalance: isLoadingMoreLeaveBalance,
    setIsLoadingMoreLeaveBalance: setIsLoadingMoreLeaveBalance,
    leaveBalanceData: leaveBalanceData,
    organisationId: organisationId,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    teamId: teamId,
    leaveBalanceStartDate: leaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    role: role
  }) : /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-no-data-text"
  }, "No leave types"))))), /*#__PURE__*/React.createElement(ViewLeaveModal, {
    viewLeaveShow: viewLeaveShow,
    handleViewLeaveClose: handleViewLeaveClose,
    getUserLeaveHistory: getUserLeaveHistory,
    userLeaveHistoryData: userLeaveHistoryData,
    userLeaveHistoryError: userLeaveHistoryError,
    userLeaveHistoryLoading: userLeaveHistoryLoading,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    userLeaveHistoryFetchMore: userLeaveHistoryFetchMore,
    startTime: startTime,
    endTime: endTime,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime
  }), /*#__PURE__*/React.createElement(ViewShortLeaveModal, {
    viewShortLeaveShow: viewShortLeaveShow,
    handleViewShortLeaveClose: handleViewShortLeaveClose,
    getUserShortLeaveHistory: getUserShortLeaveHistory,
    userShortLeaveHistoryData: userShortLeaveHistoryData,
    userShortLeaveHistoryError: userShortLeaveHistoryError,
    userShortLeaveHistoryLoading: userShortLeaveHistoryLoading,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    userShortLeaveHistoryFetchMore: userShortLeaveHistoryFetchMore,
    shortLeaveStartDate: shortLeaveStartDate,
    shortLeaveEndDate: shortLeaveEndDate
  }));
};
var PlanUpdateMsgForAdmin = function PlanUpdateMsgForAdmin(props) {
  var organisationBilling = props.organisationBilling,
    user = props.user,
    history = props.history;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-header-card"
  }, /*#__PURE__*/React.createElement("p", {
    className: "PlanUpdateMsg-text"
  }, "Dear ", user.displayName, ", Please", " ", (props === null || props === void 0 ? void 0 : props.from) === "desktop" ? "contact your Team Admin" : "".concat((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) !== "free" ? "purchase ".concat(organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName, " plan") : "upgrade your plan", " "), " ", "to use this page."), /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-button-div"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "PlanUpdateMsg-button",
    onClick: function onClick() {
      history.push("/billing");
    }
  }, "Visit Billing Page")))));
};
var columns = [{
  Header: "Employee Name",
  accessor: "employeeName"
}, {
  Header: "Applied Leave",
  accessor: "appliedLeave"
}, {
  Header: "Approved Leave",
  accessor: "approvedLeave"
}, {
  Header: "Pending Approval",
  accessor: "pendingApproval"
}, {
  Header: "Rejected Leave",
  accessor: "rejectedLeave"
}, {
  Header: "",
  accessor: "action"
}];
var LeaveHistoryTable = function LeaveHistoryTable(props) {
  var _leaveHistoryData$get, _leaveHistoryData$get2, _leaveHistoryData$get3, _leaveHistoryData$get4;
  var columns = props.columns,
    handleViewLeaveShow = props.handleViewLeaveShow,
    leaveHistoryData = props.leaveHistoryData,
    leaveHistoryError = props.leaveHistoryError,
    leaveHistoryLoading = props.leaveHistoryLoading,
    leaveHistoryFetchMore = props.leaveHistoryFetchMore;
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isAllLoaded = _React$useState26[0],
    setIsAllLoaded = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isLoadingMore = _React$useState28[0],
    setIsLoadingMore = _React$useState28[1];
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    isLoadMoreButton = _React$useState30[0],
    setIsLoadMoreButton = _React$useState30[1];
  if (leaveHistoryLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (leaveHistoryError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!leaveHistoryData) {
    return null;
  }
  if ((leaveHistoryData === null || leaveHistoryData === void 0 ? void 0 : (_leaveHistoryData$get = leaveHistoryData.getleaveHistory) === null || _leaveHistoryData$get === void 0 ? void 0 : _leaveHistoryData$get.length) !== 0 && (leaveHistoryData === null || leaveHistoryData === void 0 ? void 0 : (_leaveHistoryData$get2 = leaveHistoryData.getleaveHistory) === null || _leaveHistoryData$get2 === void 0 ? void 0 : _leaveHistoryData$get2.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var handleLoadMore = function handleLoadMore() {
    if (leaveHistoryError) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    leaveHistoryFetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref7) {
        var fetchMoreResult = _ref7.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.getleaveHistory.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.getleaveHistory.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getleaveHistory: [].concat(_toConsumableArray(prev.getleaveHistory), _toConsumableArray(fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.getleaveHistory))
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "leave-history-table-content-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-content"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "leave-history-content-new"
  }, leaveHistoryData !== null && leaveHistoryData !== void 0 && (_leaveHistoryData$get3 = leaveHistoryData.getleaveHistory) !== null && _leaveHistoryData$get3 !== void 0 && _leaveHistoryData$get3.length ? /*#__PURE__*/React.createElement("table", {
    className: "leave-history-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map(function (column) {
    // Add the sorting props to control sorting. For this example
    // we can add them into the header props
    return /*#__PURE__*/React.createElement("th", {
      className: "project-report-react-table-thead"
    }, column.Header);
  }))), /*#__PURE__*/React.createElement("tbody", null, leaveHistoryData === null || leaveHistoryData === void 0 ? void 0 : leaveHistoryData.getleaveHistory.map(function (row, i) {
    var user = row.user,
      approvedLeave = row.approvedLeave,
      pendingLeave = row.pendingLeave,
      rejectedLeave = row.rejectedLeave,
      appliedLeave = row.appliedLeave;
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      "class": "leave-history-table-content-data-details-avatar"
    }, user !== null && user !== void 0 && user.profileUrl ? /*#__PURE__*/React.createElement("div", {
      "class": "employee-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      "class": "leave-history-team-card-avatar-profile-img"
    })) : /*#__PURE__*/React.createElement("div", {
      "class": "leave-history-table-content-data-details-avatar-circle text-white"
    }, user === null || user === void 0 ? void 0 : user.displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      "class": "leave-history-content-data-details-name-data"
    }, /*#__PURE__*/React.createElement("div", {
      "class": "leave-history-content-data-details-name-data-team-name-whole"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, user === null || user === void 0 ? void 0 : user.displayName)
    }, /*#__PURE__*/React.createElement("a", {
      href: "/personal-statistics/".concat(user === null || user === void 0 ? void 0 : user.uniqueUrl)
    }, /*#__PURE__*/React.createElement("span", {
      "class": "leave-history-card-table-list-name"
    }, user === null || user === void 0 ? void 0 : user.displayName)))))), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, appliedLeave ? appliedLeave : 0, " ", appliedLeave > 1 ? "Days" : "Day"), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, approvedLeave ? approvedLeave : 0, " ", approvedLeave > 1 ? "Days" : "Day"), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, pendingLeave ? pendingLeave : 0, " ", pendingLeave > 1 ? "Days" : "Day"), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, rejectedLeave ? rejectedLeave : 0, " ", rejectedLeave > 1 ? "Days" : "Day"), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-history-table-content-view-leave-button",
      onClick: function onClick() {
        handleViewLeaveShow({
          user: user
        });
      }
    }, "View Leave History")));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "leave-history-table-content-no-data-text"
  }, "No data found !!!"), leaveHistoryData !== null && leaveHistoryData !== void 0 && (_leaveHistoryData$get4 = leaveHistoryData.getleaveHistory) !== null && _leaveHistoryData$get4 !== void 0 && _leaveHistoryData$get4.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "You have seen all the employees")) : null)));
};
var shortLeavecolumns = [{
  Header: "Employee Name",
  accessor: "employeeName"
}, {
  Header: "Applied Short Leave",
  accessor: "appliedShortLeave"
}, {
  Header: "Approved Short Leave",
  accessor: "approvedShortLeave"
}, {
  Header: "Pending Approval",
  accessor: "pendingApproval"
}, {
  Header: "Rejected Short Leave",
  accessor: "rejectedShortLeave"
}, {
  Header: "",
  accessor: "action"
}];
var ShortLeaveHistoryTable = function ShortLeaveHistoryTable(props) {
  var _leaveHistoryData$get5, _leaveHistoryData$get6, _leaveHistoryData$get7, _leaveHistoryData$get8;
  var columns = props.columns,
    handleViewLeaveShow = props.handleViewLeaveShow,
    leaveHistoryData = props.leaveHistoryData,
    leaveHistoryError = props.leaveHistoryError,
    leaveHistoryLoading = props.leaveHistoryLoading;
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    isAllLoadedShortLeave = _React$useState32[0],
    setIsAllLoadedShortLeave = _React$useState32[1];
  var _React$useState33 = React.useState(false),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    isLoadingMoreShortLeave = _React$useState34[0],
    setIsLoadingMoreShortLeave = _React$useState34[1];
  var _React$useState35 = React.useState(false),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    isLoadMoreButtonShortLeave = _React$useState36[0],
    setIsLoadMoreButtonShortLeave = _React$useState36[1];
  if (leaveHistoryLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (leaveHistoryError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!leaveHistoryData) {
    return null;
  }
  if ((leaveHistoryData === null || leaveHistoryData === void 0 ? void 0 : (_leaveHistoryData$get5 = leaveHistoryData.getShortleaveHistory) === null || _leaveHistoryData$get5 === void 0 ? void 0 : _leaveHistoryData$get5.length) !== 0 && (leaveHistoryData === null || leaveHistoryData === void 0 ? void 0 : (_leaveHistoryData$get6 = leaveHistoryData.getShortleaveHistory) === null || _leaveHistoryData$get6 === void 0 ? void 0 : _leaveHistoryData$get6.length) < LIMIT && !isAllLoadedShortLeave) {
    setIsAllLoadedShortLeave(true);
  }
  var handleLoadMore = function handleLoadMore() {
    if (leaveHistoryError) return;
    setIsLoadingMoreShortLeave(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref8) {
        var fetchMoreResult = _ref8.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.getShortleaveHistory.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.getShortleaveHistory.length) < LIMIT && !isAllLoadedShortLeave) {
          setIsAllLoadedShortLeave(true);
        }
        setIsLoadingMoreShortLeave(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getShortleaveHistory: [].concat(_toConsumableArray(prev.getShortleaveHistory), _toConsumableArray(fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.getShortleaveHistory))
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "leave-history-table-content-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-history-content"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "leave-history-content-new"
  }, leaveHistoryData !== null && leaveHistoryData !== void 0 && (_leaveHistoryData$get7 = leaveHistoryData.getShortleaveHistory) !== null && _leaveHistoryData$get7 !== void 0 && _leaveHistoryData$get7.length ? /*#__PURE__*/React.createElement("table", {
    className: "leave-history-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map(function (column) {
    // Add the sorting props to control sorting. For this example
    // we can add them into the header props
    return /*#__PURE__*/React.createElement("th", {
      className: "project-report-react-table-thead"
    }, column.Header);
  }))), /*#__PURE__*/React.createElement("tbody", null, leaveHistoryData === null || leaveHistoryData === void 0 ? void 0 : leaveHistoryData.getShortleaveHistory.map(function (row, i) {
    var user = row.user,
      approvedShortLeave = row.approvedShortLeave,
      pendingShortLeave = row.pendingShortLeave,
      rejectedShortLeave = row.rejectedShortLeave,
      appliedShortLeave = row.appliedShortLeave;
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      "class": "leave-history-table-content-data-details-avatar"
    }, user !== null && user !== void 0 && user.profileUrl ? /*#__PURE__*/React.createElement("div", {
      "class": "employee-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      "class": "leave-history-team-card-avatar-profile-img"
    })) : /*#__PURE__*/React.createElement("div", {
      "class": "leave-history-table-content-data-details-avatar-circle text-white"
    }, user === null || user === void 0 ? void 0 : user.displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      "class": "leave-history-content-data-details-name-data"
    }, /*#__PURE__*/React.createElement("div", {
      "class": "leave-history-content-data-details-name-data-team-name-whole"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, user === null || user === void 0 ? void 0 : user.displayName)
    }, /*#__PURE__*/React.createElement("a", {
      href: "/personal-statistics/".concat(user === null || user === void 0 ? void 0 : user.uniqueUrl)
    }, /*#__PURE__*/React.createElement("span", {
      "class": "leave-history-card-table-list-name"
    }, user === null || user === void 0 ? void 0 : user.displayName)))))), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, appliedShortLeave ? appliedShortLeave : 0), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, approvedShortLeave ? approvedShortLeave : 0), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, pendingShortLeave ? pendingShortLeave : 0), /*#__PURE__*/React.createElement("td", null, rejectedShortLeave ? rejectedShortLeave : 0), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleViewLeaveShow({
          user: user
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-history-table-content-view-leave-button",
      onClick: function onClick() {
        handleViewLeaveShow({
          user: user
        });
      }
    }, "View Short Leave History")));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "leave-history-table-content-no-data-text"
  }, "No data found !!!"), leaveHistoryData !== null && leaveHistoryData !== void 0 && (_leaveHistoryData$get8 = leaveHistoryData.getShortleaveHistory) !== null && _leaveHistoryData$get8 !== void 0 && _leaveHistoryData$get8.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoadedShortLeave ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMoreShortLeave && !isLoadMoreButtonShortLeave ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "You have seen all the employees")) : null)));
};
var ViewLeaveModal = function ViewLeaveModal(props) {
  var _viewLeaveShow$user, _viewLeaveShow$user2, _leaveSettingsApprove7, _leaveSettingsApprove8, _userLeaveHistoryData, _userLeaveHistoryData2, _userLeaveHistoryData3, _userLeaveHistoryData4;
  var viewLeaveShow = props.viewLeaveShow,
    handleViewLeaveClose = props.handleViewLeaveClose,
    getUserLeaveHistory = props.getUserLeaveHistory,
    userLeaveHistoryLoading = props.userLeaveHistoryLoading,
    userLeaveHistoryData = props.userLeaveHistoryData,
    userLeaveHistoryError = props.userLeaveHistoryError,
    organisationId = props.organisationId,
    organisationTimezone = props.organisationTimezone,
    userLeaveHistoryFetchMore = props.userLeaveHistoryFetchMore,
    startTime = props.startTime,
    endTime = props.endTime,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData,
    leaveStartTime = props.leaveStartTime,
    leaveEndTime = props.leaveEndTime;
  var userId = viewLeaveShow === null || viewLeaveShow === void 0 ? void 0 : (_viewLeaveShow$user = viewLeaveShow.user) === null || _viewLeaveShow$user === void 0 ? void 0 : _viewLeaveShow$user.userId;
  var displayName = viewLeaveShow === null || viewLeaveShow === void 0 ? void 0 : (_viewLeaveShow$user2 = viewLeaveShow.user) === null || _viewLeaveShow$user2 === void 0 ? void 0 : _viewLeaveShow$user2.displayName;
  var _React$useState37 = React.useState(false),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    isAllLoadedLeaveModal = _React$useState38[0],
    setIsAllLoadedLeaveModal = _React$useState38[1];
  var _React$useState39 = React.useState(false),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    isLoadingMoreLeaveModal = _React$useState40[0],
    setIsLoadingMoreLeaveModal = _React$useState40[1];
  var _React$useState41 = React.useState(false),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    isLoadMoreButtonLeaveModal = _React$useState42[0],
    setIsLoadMoreButtonLeaveModal = _React$useState42[1];

  // Per-instance, resets every time the modal is (re)opened - a module-level
  // counter kept incrementing across different users/opens and was never
  // reset back to 0, so a later "Load more" click could ask for an offset
  // past what the newly opened user actually has (backend correctly returns
  // an empty page for that).
  var leaveOffsetRef = React.useRef(0);
  var leaveYearStartTime = (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove7 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove7 === void 0 ? void 0 : _leaveSettingsApprove7.leaveYearSettings) !== "financial-year" ? startTime : leaveStartTime;
  var leaveYearEndTime = (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove8 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove8 === void 0 ? void 0 : _leaveSettingsApprove8.leaveYearSettings) !== "financial-year" ? endTime : leaveEndTime;
  useEffect(function () {
    if (viewLeaveShow && userId) {
      leaveOffsetRef.current = 0;
      setIsAllLoadedLeaveModal(false);
      setIsLoadingMoreLeaveModal(false);
      getUserLeaveHistory({
        variables: {
          organisationId: organisationId,
          userId: userId,
          timeZone: organisationTimezone,
          limit: USER_LEAVE_LIMIT,
          offset: 0,
          leaveYearStartTime: leaveYearStartTime,
          leaveYearEndTime: leaveYearEndTime
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewLeaveShow, userId]);
  if (!viewLeaveShow) {
    return null;
  }
  var handleLoadMore = function handleLoadMore() {
    if (isLoadingMoreLeaveModal || isAllLoadedLeaveModal) return;
    setIsLoadingMoreLeaveModal(true);
    leaveOffsetRef.current = leaveOffsetRef.current + 1;
    userLeaveHistoryFetchMore({
      variables: {
        organisationId: organisationId,
        userId: userId,
        timeZone: organisationTimezone,
        limit: USER_LEAVE_LIMIT,
        offset: leaveOffsetRef.current * USER_LEAVE_LIMIT,
        leaveYearStartTime: leaveYearStartTime,
        leaveYearEndTime: leaveYearEndTime
      },
      updateQuery: function updateQuery(prev, _ref9) {
        var _fetchMoreResult$user, _fetchMoreResult$user2;
        var fetchMoreResult = _ref9.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$user = fetchMoreResult.userLeaveHistory) === null || _fetchMoreResult$user === void 0 ? void 0 : _fetchMoreResult$user.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$user2 = fetchMoreResult.userLeaveHistory) === null || _fetchMoreResult$user2 === void 0 ? void 0 : _fetchMoreResult$user2.length) < LIMIT && !isAllLoadedLeaveModal) {
          setIsAllLoadedLeaveModal(true);
        }
        setIsLoadingMoreLeaveModal(false);
        var NewFilterData = [];
        fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.userLeaveHistory.forEach(function (newLeave) {
          var found = prev === null || prev === void 0 ? void 0 : prev.userLeaveHistory.find(function (item) {
            return item.leaveId === newLeave.leaveId;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newLeave);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          userLeaveHistory: [].concat(_toConsumableArray(prev.userLeaveHistory), NewFilterData)
        });
      }
    });
  };
  if ((userLeaveHistoryData === null || userLeaveHistoryData === void 0 ? void 0 : (_userLeaveHistoryData = userLeaveHistoryData.userLeaveHistory) === null || _userLeaveHistoryData === void 0 ? void 0 : _userLeaveHistoryData.length) !== 0 && (userLeaveHistoryData === null || userLeaveHistoryData === void 0 ? void 0 : (_userLeaveHistoryData2 = userLeaveHistoryData.userLeaveHistory) === null || _userLeaveHistoryData2 === void 0 ? void 0 : _userLeaveHistoryData2.length) < USER_LEAVE_LIMIT && !isAllLoadedLeaveModal) {
    setIsAllLoadedLeaveModal(true);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: viewLeaveShow,
    onHide: handleViewLeaveClose,
    animation: false,
    size: "lg",
    className: "view-user-leave-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "view-user-leave-modal-header-title"
  }, "".concat(displayName, " Leave History"))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    "class": "view-leave-history-content-new"
  }, userLeaveHistoryLoading ? /*#__PURE__*/React.createElement(Loader, null) : userLeaveHistoryError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : userLeaveHistoryData !== null && userLeaveHistoryData !== void 0 && (_userLeaveHistoryData3 = userLeaveHistoryData.userLeaveHistory) !== null && _userLeaveHistoryData3 !== void 0 && _userLeaveHistoryData3.length ? /*#__PURE__*/React.createElement("table", {
    className: "view-user-leave-history-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Leave Period"), /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Days"), /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Type"), /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Leave Reason"), /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Status"))), /*#__PURE__*/React.createElement("tbody", null, userLeaveHistoryData === null || userLeaveHistoryData === void 0 ? void 0 : userLeaveHistoryData.userLeaveHistory.map(function (row, i) {
    var leaveId = row.leaveId,
      leaveType = row.leaveType,
      leaveStartDate = row.leaveStartDate,
      leaveEndDate = row.leaveEndDate,
      leaveDays = row.leaveDays,
      appliedStatus = row.appliedStatus,
      leaveReason = row.leaveReason,
      appliedAt = row.appliedAt,
      leaveStartDateFormat = row.leaveStartDateFormat,
      leaveEndDateFormat = row.leaveEndDateFormat,
      dateDetails = row.dateDetails;
    var leaveTypeValue = leaveType.replace(/-/g, " ");
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, leaveEndDate ? "".concat(leaveStartDateFormat, " - ").concat(leaveEndDateFormat) : leaveStartDateFormat), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "user-leave-listing-tab-tab-Content-list-dates-count-span"
    }, leaveDays, " ", leaveDays > 1 ? "Days" : "Day", " "), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "view-leave-balanace-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", {
        className: "view-leave-balanace-count-tooltip-user-content"
      }, dateDetails.map(function (dateValue) {
        return /*#__PURE__*/React.createElement("div", {
          className: "view-leave-balanace-count-tooltip-user-content-div"
        }, /*#__PURE__*/React.createElement("span", null, dateValue.dateFormatTooltip, ": "), /*#__PURE__*/React.createElement("span", {
          className: "view-leave-balanace-tooltip-start-span"
        }, dateValue.dayType == "full-day" ? "Full Day" : dateValue.dayType == "half-day-first-half" || dateValue.dayType == "non-working-day" && dateValue.nonWorkingDayLeaveSession == "half-day-first-half" ? "Half day - 1st Half" : dateValue.dayType == "half-day-second-half" || dateValue.dayType == "non-working-day" && dateValue.nonWorkingDayLeaveSession == "half-day-second-half" ? "Half day - 2nd Half" : dateValue.dayType == "non-working-day" && (dateValue.nonWorkingDayLeaveSession == "full-day" || dateValue.nonWorkingDayLeaveSession == null) ? "Non Working Day" : null));
      })))
    }, /*#__PURE__*/React.createElement("span", {
      className: "leave-listing-tab-tab-Content-list-dates-count-span-icon"
    }, /*#__PURE__*/React.createElement(MdInfoOutline, null)))), /*#__PURE__*/React.createElement("td", {
      className: "leave-summary-user-leave-details-leave-type"
    }, leaveTypeValue), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, decodeHtmlEntities(leaveReason))
    }, /*#__PURE__*/React.createElement("div", {
      className: "view-user-leave-history-table-leave-reason"
    }, decodeHtmlEntities(leaveReason)))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "view-user-leave-history-table-status view-user-leave-history-table-".concat(appliedStatus, "-status")
    }, appliedStatus)));
  }))) : "No data found !!!", userLeaveHistoryData !== null && userLeaveHistoryData !== void 0 && (_userLeaveHistoryData4 = userLeaveHistoryData.userLeaveHistory) !== null && _userLeaveHistoryData4 !== void 0 && _userLeaveHistoryData4.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoadedLeaveModal ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMoreLeaveModal && !isLoadMoreButtonLeaveModal ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "You have seen all the leaves")) : null)));
};
var LeaveBalance = function LeaveBalance(props) {
  var headers = props.headers,
    gridData = props.gridData,
    leaveBalanceFetchMore = props.leaveBalanceFetchMore,
    leaveBalanceLoading = props.leaveBalanceLoading,
    isAllLoadedLeaveBalance = props.isAllLoadedLeaveBalance,
    setIsAllLoadedLeaveBalance = props.setIsAllLoadedLeaveBalance,
    isLoadingMoreLeaveBalance = props.isLoadingMoreLeaveBalance,
    setIsLoadingMoreLeaveBalance = props.setIsLoadingMoreLeaveBalance,
    leaveBalanceData = props.leaveBalanceData,
    organisationId = props.organisationId,
    timeZone = props.timeZone,
    teamId = props.teamId,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    role = props.role;
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    leaveTypeModalShow = _useState12[0],
    setleaveTypeShow = _useState12[1];
  var Headers = [];
  if (headers) {
    Headers = [{
      Header: "Employees",
      accessor: "employee"
    }].concat(_toConsumableArray(headers), [{
      Header: "Total Leave Taken",
      accessor: "totalLeave"
    }]);
  }
  var handleLoadMore = function handleLoadMore() {
    var _leaveBalanceData$get8, _leaveBalanceData$get9;
    if (leaveBalanceLoading) return;
    setIsLoadingMoreLeaveBalance(true);
    leaveBalanceFetchMore({
      variables: {
        offset: leaveBalanceData === null || leaveBalanceData === void 0 ? void 0 : (_leaveBalanceData$get8 = leaveBalanceData.getLeaveSummaryBalance) === null || _leaveBalanceData$get8 === void 0 ? void 0 : (_leaveBalanceData$get9 = _leaveBalanceData$get8.userData) === null || _leaveBalanceData$get9 === void 0 ? void 0 : _leaveBalanceData$get9.length
      },
      updateQuery: function updateQuery(prev, _ref10) {
        var _fetchMoreResult$getL, _fetchMoreResult$getL2, _fetchMoreResult$getL3, _fetchMoreResult$getL4, _prev$getLeaveSummary, _fetchMoreResult$getL5;
        var fetchMoreResult = _ref10.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getL = fetchMoreResult.getLeaveSummaryBalance) === null || _fetchMoreResult$getL === void 0 ? void 0 : (_fetchMoreResult$getL2 = _fetchMoreResult$getL.userData) === null || _fetchMoreResult$getL2 === void 0 ? void 0 : _fetchMoreResult$getL2.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getL3 = fetchMoreResult.getLeaveSummaryBalance) === null || _fetchMoreResult$getL3 === void 0 ? void 0 : (_fetchMoreResult$getL4 = _fetchMoreResult$getL3.userData) === null || _fetchMoreResult$getL4 === void 0 ? void 0 : _fetchMoreResult$getL4.length) < LIMIT && !isAllLoadedLeaveBalance) {
          setIsAllLoadedLeaveBalance(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMoreLeaveBalance(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getLeaveSummaryBalance: _objectSpread(_objectSpread({}, prev.getLeaveSummaryBalance), {}, {
            userData: [].concat(_toConsumableArray((_prev$getLeaveSummary = prev.getLeaveSummaryBalance) === null || _prev$getLeaveSummary === void 0 ? void 0 : _prev$getLeaveSummary.userData), _toConsumableArray((_fetchMoreResult$getL5 = fetchMoreResult.getLeaveSummaryBalance) === null || _fetchMoreResult$getL5 === void 0 ? void 0 : _fetchMoreResult$getL5.userData))
          })
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  var handleLeaveTypeShow = function handleLeaveTypeShow(userId, employee, data) {
    setleaveTypeShow({
      userId: userId,
      displayName: employee,
      data: data
    });
  };
  var handleLeaveTypeClose = function handleLeaveTypeClose() {
    setleaveTypeShow(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-summary-leave-balance-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-summary-leave-balance-content-view"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-summary-leave-balance-content-wrapper"
  }, leaveBalanceLoading ? /*#__PURE__*/React.createElement(Loader, null) : !leaveBalanceData ? /*#__PURE__*/React.createElement("div", null, "No data") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    className: "leave-summary-leave-balance-content-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "leave-summary-leave-balance-table-thead"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "leave-summary-leave-balance-table-thead-table-row"
  }, Headers.map(function (employeeHeader, index) {
    return /*#__PURE__*/React.createElement("th", {
      colSpan: employeeHeader.type == "date" ? 2 : 1,
      key: "header-".concat(index),
      className: index == 0 ? "monthly-in-out-content-sticky-col first-col" : "",
      rowSpan: employeeHeader.type != "date" ? 2 : 1
    }, employeeHeader.Header, " ", employeeHeader.leaveCycle ? "(".concat(employeeHeader.leaveCycle, ")") : "");
  })), /*#__PURE__*/React.createElement("tr", {
    className: "leave-summary-leave-balance-table-thead-table-row"
  }, Headers.map(function (employeeHeader, index) {
    return employeeHeader.columns && employeeHeader.columns.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", {
      key: "header-in-".concat(index)
    }, employeeHeader.columns[0].Header), /*#__PURE__*/React.createElement("th", {
      key: "header-out-".concat(index)
    }, employeeHeader.columns[1].Header)) : /*#__PURE__*/React.createElement(React.Fragment, null);
  }))), /*#__PURE__*/React.createElement("tbody", null, gridData.map(function (employeeData, index) {
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      key: "index",
      className: "monthly-in-out-content-sticky-col summary-leave-balanace-modal-avartar-emp first-col"
    }, employeeData.profileUrl === null || employeeData.profileUrl === "" ? /*#__PURE__*/React.createElement("div", {
      className: "summary-leave-balanace-modal-header-avatar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "summary-leave-balanace-modal-avartar"
    }, employeeData.employee.charAt(0).toUpperCase())) : /*#__PURE__*/React.createElement("div", {
      className: "summary-leave-balanace-modal-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: employeeData.profileUrl,
      className: "summary-leave-balanace-modal-avartar-img"
    })), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, employeeData === null || employeeData === void 0 ? void 0 : employeeData.employee)
    }, /*#__PURE__*/React.createElement("a", {
      href: "/personal-statistics/".concat(employeeData === null || employeeData === void 0 ? void 0 : employeeData.uniqueUrl)
    }, /*#__PURE__*/React.createElement("div", {
      className: "summary-leave-balanace-modal-avatar-profile-name"
    }, employeeData.employee, " "))), /*#__PURE__*/React.createElement("div", {
      className: "summary-leave-balanace-modal-header-avatar-edit",
      onClick: function onClick() {
        return handleLeaveTypeShow(employeeData === null || employeeData === void 0 ? void 0 : employeeData.userId, employeeData.employee, employeeData.date);
      }
    }, "Edit Balance")), employeeData.date.map(function (employeeDate, index) {
      // console.log("Object.keys(employeeDate.data).length", Object.keys(employeeDate.data));
      return employeeDate.data.available == "private" && employeeDate.data.booked == "private" ? /*#__PURE__*/React.createElement("td", {
        key: index,
        colSpan: 2,
        className: "monthly-in-out-content-table-tbody-td-absent"
      }, "Not Available") : employeeDate.value != "" ? /*#__PURE__*/React.createElement("td", {
        key: index,
        colSpan: 2,
        className: "monthly-in-out-content-table-tbody-td-absent"
      }, employeeDate.value == "-" ? "" : employeeDate.value) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
        key: index
      }, employeeDate.data.available, employeeDate.data.available !== "Unlimited Leave" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "summary-leave-balanace-tooltip-start"
        }, /*#__PURE__*/React.createElement("div", {
          className: "summary-leave-balanace-count-tooltip-user-content summary-leave-balanace-count-tooltip-whole"
        }, /*#__PURE__*/React.createElement("div", null, "Carry Forward Balance:", " ", /*#__PURE__*/React.createElement("span", {
          className: "summary-leave-balanace-tooltip-start-span"
        }, employeeDate.data.carryForwardCount)), /*#__PURE__*/React.createElement("div", null, "Default Leave Balance:", " ", /*#__PURE__*/React.createElement("span", {
          className: "summary-leave-balanace-tooltip-start-span"
        }, employeeDate.data.leaveCount)), /*#__PURE__*/React.createElement("div", null, "Available (Remaining) Leave Balance:", " ", /*#__PURE__*/React.createElement("span", {
          className: "summary-leave-balanace-tooltip-start-span"
        }, employeeDate.data.available))))
      }, /*#__PURE__*/React.createElement("span", {
        className: "summary-leave-balanace-header-summary-card-text-ques"
      }, /*#__PURE__*/React.createElement(MdInfoOutline, null))) : null), /*#__PURE__*/React.createElement("td", {
        key: index
      }, employeeDate.data.booked));
    }), /*#__PURE__*/React.createElement("td", {
      key: index
    }, employeeData.totalLeave));
  })))), !leaveBalanceLoading && leaveBalanceData && leaveBalanceData.length != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-in-out-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoadedLeaveBalance ? isLoadingMoreLeaveBalance ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the users")) : null))), /*#__PURE__*/React.createElement(LeaveTypeModal, {
    leaveTypeModalShow: leaveTypeModalShow,
    handleLeaveTypeClose: handleLeaveTypeClose,
    organisationId: organisationId,
    timeZone: timeZone,
    teamId: teamId,
    leaveBalanceStartDate: leaveBalanceStartDate,
    leaveBalanceEndDate: leaveBalanceEndDate,
    role: role
  }));
};
function TimeFilter(props) {
  var onClose = props.onClose,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    setLeaveBalanceStartDate = props.setLeaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    setLeaveBalanceEndDate = props.setLeaveBalanceEndDate,
    organisationBilling = props.organisationBilling;
  var handleDateChange = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            setLeaveBalanceStartDate(e[0]);
            setLeaveBalanceEndDate(e[1]);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function handleDateChange(_x4) {
      return _ref11.apply(this, arguments);
    };
  }();
  var datePickerMinDate = stringToArrayOutput("Free Plan Days");
  var datepickerPermissionForPast = stringToArrayOutput("Today");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-datepicker"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    selected: leaveBalanceStartDate,
    onChange: function onChange(e) {
      handleDateChange(e);
      //handleFilterChange(e);
    },
    startDate: leaveBalanceStartDate,
    endDate: leaveBalanceEndDate,
    selectsRange: true,
    showMonthYearPicker: true
    // minDate={
    //   permissionSettingData?.leaveSettingsPermission?.leavePermissions == "false"
    //     ? datepickerPermissionForPast[0]
    //     : organisationBilling?.planName == "free" || organisationBilling?.planStatus == "stopped"
    //     ? datePickerMinDate[0]
    //     : ""
    // }
  }))));
}
var convertOrganisationTimezoneForFilter = function convertOrganisationTimezoneForFilter(sD, tz) {
  var startTime = moment(sD).format("YYYY-MM-DD HH:mm:ss");
  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(tz).utcOffset();
  if (zoneoffset !== currentSystemOffset) {
    var zoneoffsetTemp = Math.abs(zoneoffset);
    var currentSystemOffsetTemp = Math.abs(currentSystemOffset);
    if (zoneoffset > 0) {
      zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
    } else {
      zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
    }
  }
  if (zoneoffset >= 0) {
    startTime = moment(startTime).toDate();
    if (zoneoffset !== currentSystemOffset) {
      startTime = moment(startTime).add(zoneoffset, "minutes").toDate();
    }
  } else {
    zoneoffset = Math.abs(zoneoffset);
    startTime = moment(startTime).add(zoneoffset, "minutes").toDate();
  }
  var startLoopingDate = moment(startTime).format("MMM,YYYY");
  return startLoopingDate;
};
export var arrayToStringOutput = function arrayToStringOutput(arrayData, tz) {
  var sD = arrayData[0];
  var eD = arrayData[1] ? arrayData[1] : null;
  var startDate = convertOrganisationTimezoneForFilter(sD, tz);
  var endDate = null;
  if (eD) {
    endDate = convertOrganisationTimezoneForFilter(eD, tz);
  }
  return moment(startDate).isSame(endDate, "day") ? startDate : endDate ? "".concat(startDate, " - ").concat(endDate) : startDate;
};
var monthsArray = [{
  label: "".concat(moment().add(1, "month").format("MMMM"), " "),
  value: "".concat(moment().add(1, "month").format("MMMM"))
}, {
  label: "".concat(moment().add(2, "month").format("MMMM"), " "),
  value: "".concat(moment().add(2, "month").format("MMMM"))
}, {
  label: "".concat(moment().add(3, "month").format("MMMM"), " "),
  value: "".concat(moment().add(3, "month").format("MMMM"))
}, {
  label: "".concat(moment().add(4, "month").format("MMMM"), " "),
  value: "".concat(moment().add(4, "month").format("MMMM"))
}, {
  label: "".concat(moment().add(5, "month").format("MMMM"), " "),
  value: "".concat(moment().add(5, "month").format("MMMM"))
}];
var yearList = [{
  label: "".concat(moment().add(1, "year").format("YYYY"), " "),
  value: "".concat(moment().add(1, "year").format("YYYY"))
}, {
  label: "".concat(moment().add(2, "year").format("YYYY"), " "),
  value: "".concat(moment().add(2, "year").format("YYYY"))
}];
var LeaveTypesSchema = Yup.object().shape({
  leaveType: Yup.string().trim().required("Required"),
  defaultBalance: Yup.number().required("Required")
  // updateType: Yup.string()
  // .trim()
  // .oneOf(["futureMonth" ,"singleMonth","pastAndFutureMonth" ], "Invalid update type") // Allowed values
  // .required("Please select a update type")
});
var LeaveTypesCurrentSchema = Yup.object().shape({
  leaveType: Yup.string().trim().required("Required"),
  availableBalanceForCurrent: Yup.number().required("Required")
});
var LeaveTypeModal = function LeaveTypeModal(props) {
  var leaveTypeModalShow = props.leaveTypeModalShow,
    handleLeaveTypeClose = props.handleLeaveTypeClose,
    organisationId = props.organisationId,
    timeZone = props.timeZone,
    teamId = props.teamId,
    leaveBalanceStartDate = props.leaveBalanceStartDate,
    leaveBalanceEndDate = props.leaveBalanceEndDate,
    role = props.role;
  if (leaveTypeModalShow == null) {
    return null;
  }

  //const [selectUserList, setSelectUserList] = React.useState(userId);
  var _React$useState43 = React.useState("current-month"),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    tabData = _React$useState44[0],
    setTabData = _React$useState44[1];
  var _React$useState45 = React.useState([]),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    countData = _React$useState46[0],
    setCountData = _React$useState46[1];
  var _React$useState47 = React.useState(null),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    resetTime = _React$useState48[0],
    setResetTime = _React$useState48[1];
  var _React$useState49 = React.useState(moment().format("MMMM")),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    startDate = _React$useState50[0],
    setStartDate = _React$useState50[1];

  // const innerRef = useRef();

  // useEffect(() => {
  //   innerRef.current && innerRef.current.focus();
  // }, [leaveTypeModalShow]);

  var _useQuery4 = useQuery(LIST_LEAVE_TYPE_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: leaveTypeModalShow.userId,
        timeZone: timeZone,
        startDate: startDate
      },
      skip: !organisationId
    }),
    leaveTypeListData = _useQuery4.data,
    leaveTypeListError = _useQuery4.error,
    leaveTypeListLoading = _useQuery4.loading,
    leaveTypeRefetch = _useQuery4.refetch;
  var _useMutation = useMutation(EDIT_USER_LEAVE_BALANCE_AVAILABLE_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    editUserLeaveBalanceAvailable = _useMutation2[0],
    editUserLeaveBalanceAvailableLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(EDIT_USER_LEAVE_BALANCE_DEFAULT_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    editUserLeaveBalanceDefault = _useMutation4[0],
    editUserLeaveBalanceDefaultLoading = _useMutation4[1].loading;
  React.useEffect(function () {
    if (startDate) {
      leaveTypeRefetch();
    }
  }, [startDate]);
  var handleCurrentMonthSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(values, actions) {
      var leaveType, availableBalanceForCurrent, response;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            leaveType = values.leaveType, availableBalanceForCurrent = values.availableBalanceForCurrent;
            _context8.prev = 1;
            _context8.next = 4;
            return editUserLeaveBalanceAvailable({
              variables: {
                organisationId: organisationId,
                leaveTypeId: leaveType,
                userId: leaveTypeModalShow.userId,
                availableBalanceNew: availableBalanceForCurrent,
                timeZone: timeZone,
                resetTime: resetTime
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LIST_LEAVE_TYPE_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: leaveTypeModalShow.userId,
                  timeZone: timeZone,
                  startDate: startDate
                }
              }, {
                query: LEAVE_BALANCE_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: null,
                  startTime: Number(leaveBalanceStartDate),
                  endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate),
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  userRole: role
                }
              }]
            });
          case 4:
            response = _context8.sent;
            if (!response || !response.data || response.data.editUserLeaveBalanceAvailable == false) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              // Resets form after submission is complete
              actions.resetForm();
              actions.setSubmitting(false);
              toast.success("Balance edited successfully!");
              handleLeaveTypeClose();
            }
            _context8.next = 12;
            break;
          case 8:
            _context8.prev = 8;
            _context8.t0 = _context8["catch"](1);
            // editUserLeaveBalanceAvailable is capped at 10 per minute per user by
            // the leave-balance-edits limiter in the middleware, so a 429 arrives as
            // an Apollo *network* error - its reason is not in error.message, which
            // would read "Response not successful: Received status code 429".
            // rateLimitMessage reads the limiter's own text out of the 429 body, so
            // the window stays right if that limit is ever retuned.
            if (isRateLimited(_context8.t0)) {
              toast.error(rateLimitMessage(_context8.t0, "You’ve reached the limit of 10 requests per minute. Please try again in a minute."));
            } else {
              if (_context8.t0.message.includes("Leave type already exist")) {
                actions.setFieldError("leaveTypes", "Already Exists");
              }
              toast.error("Error Occurred, Try again later!!!");
            }
            actions.setSubmitting(false);
          case 12:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[1, 8]]);
    }));
    return function (_x5, _x6) {
      return _ref12.apply(this, arguments);
    };
  }(), [leaveTypeModalShow, resetTime, startDate, tabData]);

  // const handleDefaultBalanceSubmit = React.useCallback(
  //   async (values, actions) => {
  //     const {
  //       leaveType,
  //       defaultBalance,
  //       //monthSelection,
  //       //updateType
  //     } = values;
  //     // console.log({monthSelection})
  //     // console.log({updateType})

  //     try {
  //       const response = await editUserLeaveBalanceDefault({
  //         variables: {
  //           organisationId,
  //           leaveTypeId: leaveType,
  //           userId: leaveTypeModalShow.userId,
  //           defaultBalanceNew: defaultBalance,
  //           timeZone,
  //           //monthSelection,
  //           updatedType: "futureMonth",
  //           resetTime,
  //         },
  //         awaitRefetchQueries: true,
  //         refetchQueries: [
  //           {
  //             query: LIST_LEAVE_TYPE_QUERY,
  //             variables: {
  //               organisationId,
  //               userId: leaveTypeModalShow.userId,
  //               timeZone,
  //               startDate,
  //             },
  //           },
  //           {
  //             query: LEAVE_BALANCE_QUERY,
  //             variables: {
  //               organisationId,
  //               teamId,
  //               userId: null,
  //               startTime: Number(leaveBalanceStartDate),
  //               endTime: leaveBalanceEndDate ? Number(leaveBalanceEndDate) : Number(leaveBalanceStartDate),
  //               timeZone: timeZone,
  //               limit: LIMIT,
  //               offset: 0,
  //               userRole: role,
  //             },
  //           },
  //         ],
  //       });

  //       if (!response || !response.data || response.data.editUserLeaveBalanceDefault == false) {
  //         toast.error("Error Occurred, Try again later!!!");
  //       } else {
  //         // Resets form after submission is complete
  //         actions.resetForm();
  //         actions.setSubmitting(false);

  //         toast.success("Balance edited successfully!");
  //         handleLeaveTypeClose();
  //       }
  //     } catch (error) {
  //       if (error.message.includes("Leave type already exist")) {
  //         actions.setFieldError("leaveTypes", "Already Exists");
  //       }
  //       toast.error("Error Occurred, Try again later!!!");
  //       actions.setSubmitting(false);
  //     }
  //   },
  //   [leaveTypeModalShow, tabData, resetTime, startDate]
  // );

  var array = ["primary"];

  // if(leaveTypeListLoading){
  //   return <Loader />;
  // }

  var handleTabSelect = function handleTabSelect(key) {
    setTabData(key);
  };

  //console.log({tabData});

  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleLeaveTypeClose,
    centered: true,
    animation: false
    //size="lg"
    ,
    backdrop: "static",
    className: "apply-leave-modal apply-leave-new-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "edit-user-wise-leave-settings-modal-title"
  }, "Edit Leave Balance for ", leaveTypeModalShow.displayName)), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      leaveType: "",
      defaultBalance: 0,
      // updateType: resetTime == "Monthly" ? "singleMonth" : "futureMonth",

      /* current month field*/
      availableBalanceForCurrent: 0
    },
    validationSchema: tabData == "current-month" ? LeaveTypesCurrentSchema : LeaveTypesSchema,
    onSubmit: tabData == "current-month" ? handleCurrentMonthSubmit : handleDefaultBalanceSubmit
  }, function (_ref13) {
    var setFieldValue = _ref13.setFieldValue,
      errors = _ref13.errors,
      touched = _ref13.touched,
      values = _ref13.values;
    // React.useEffect(() => {
    //   if (leaveTypeListData?.getleaveHistroyTypeList?.length) {
    //     const selectedLeaveType = leaveTypeListData.getleaveHistroyTypeList.find(
    //       (o) => o.value === values.leaveType
    //     );

    //     if (selectedLeaveType) {
    //       setResetTime(selectedLeaveType?.resetLeaveBalance);
    //       //console.log({resetTime,selectedLeaveType});
    //       setFieldValue("defaultBalance", selectedLeaveType.leaveTypeCount);
    //     }

    //   }
    // }, [leaveTypeListData, values.leaveType,setFieldValue]);

    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-wise-Leave-type-modal-grid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-wise-Leave-type-modal-grid-left"
    }, /*#__PURE__*/React.createElement("div", {
      className: "edit-user-wise-Leave-type-modal-grid-left-content"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "leaveType"
    }, function (_ref14) {
      var _leaveTypeListData$ge;
      var field = _ref14.field,
        form = _ref14.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Leave Type"), errors.leaveType && touched.leaveType ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error apply-leave-modal-error"
      }, errors.leaveType) : null, leaveTypeListLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        className: "apply-leave-modal-body-wrapper-form-div-field-input"
      }, field, {
        onChange: function onChange(e) {
          var leaveSettingsTypeData = leaveTypeListData === null || leaveTypeListData === void 0 ? void 0 : leaveTypeListData.getleaveHistroyTypeList.find(function (o) {
            return o.value == e.target.value;
          });
          setFieldValue("leaveType", e.target.value);
          setFieldValue("defaultBalance", leaveSettingsTypeData.leaveTypeCount);
          setFieldValue("availableBalanceForCurrent", leaveSettingsTypeData.available);
          // setFieldValue(`updateType`,  leaveSettingsTypeData.resetLeaveBalance == "Monthly" ? "singleMonth" : "futureMonth");
          setResetTime(leaveSettingsTypeData.resetLeaveBalance);
          var month = moment().add(1, "month").format("MMMM");
          //setFieldValue(`monthSelection`, month);
          setStartDate(month);
        }
      }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("option", {
        key: "select-leave-type",
        value: " "
      }, "Select Leave Type"), leaveTypeListData === null || leaveTypeListData === void 0 ? void 0 : (_leaveTypeListData$ge = leaveTypeListData.getleaveHistroyTypeList) === null || _leaveTypeListData$ge === void 0 ? void 0 : _leaveTypeListData$ge.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.value
        }, key.label);
      }))));
    }), /*#__PURE__*/React.createElement("div", {
      className: "edit-user-wise-leave-history-tab-available"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "availableBalanceForCurrent"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "leave-setting-time-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "count",
        type: "number",
        min: "0",
        step: "0.5",
        placeholder: "Enter number of leave balance days",
        className: "leave-settings-edit-task-label-input"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "leave-setting-time-option-div-hours-text"
      }, "Days")));
    }), /*#__PURE__*/React.createElement("p", {
      className: "user-wise-leave-balance-month-settings-span"
    }, "The given balance will be applied to the current", " ", resetTime == "Annually" ? "year" : "month"))))), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "project-task-modals-save-button Leave-edit-balance-modal-notes-header-button",
      type: "submit",
      disabled: editUserLeaveBalanceAvailableLoading || editUserLeaveBalanceDefaultLoading
    }, tabData == "current-month" ? "Update Leave Balance" : "Update Leave Balance"), /*#__PURE__*/React.createElement("div", {
      className: "Leave-edit-balance-modal-notes-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Leave-edit-balance-modal-notes-header-note-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "Leave-edit-balance-modal-notes-header-note-text-span"
    }, "Available Leave Balance"), ": Editing an employee\u2019s leave balance updates the current month\u2019s leave (for monthly leave) or the current year\u2019s leave (for annual leave). This change does not impact future months or the default leave balance settings."), /*#__PURE__*/React.createElement("div", {
      className: "Leave-edit-balance-modal-notes-header-note-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "Leave-edit-balance-modal-notes-header-note-text-span"
    }, "Default Leave Balance Settings"), ": Adjusting the default leave balance will not affect the current month/year's leave balance. Instead, the updated balance will apply from the next month (for monthly leave) or the next year (for annual leave)."), /*#__PURE__*/React.createElement("p", {
      className: "Leave-edit-balance-modal-notes-header-note-text-p"
    }, "Need help with leave editing? Check this guide:", " ", /*#__PURE__*/React.createElement("a", {
      href: "https://workfolio.tawk.help/article/how-to-edit-leave-balance-for-an-employee",
      className: "font-weight-bold"
    }, "How to Edit Leave Balance"), "."))));
  })));
};
function ShortLeaveTimeFilter(props) {
  var onClose = props.onClose,
    shortLeaveStartDate = props.shortLeaveStartDate,
    setShortLeaveStartDate = props.setShortLeaveStartDate,
    shortLeaveEndDate = props.shortLeaveEndDate,
    setShortLeaveEndDate = props.setShortLeaveEndDate,
    organisationBilling = props.organisationBilling;
  var handleDateChange = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e) {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            setShortLeaveStartDate(e[0]);
            setShortLeaveEndDate(e[1]);
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function handleDateChange(_x7) {
      return _ref15.apply(this, arguments);
    };
  }();
  var datePickerMinDate = stringToArrayOutput("Free Plan Days");
  var datepickerPermissionForPast = stringToArrayOutput("Today");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "apply-leave-modal-body-wrapper-form-date-picker-filter-overlay-datepicker"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    selected: shortLeaveStartDate,
    onChange: function onChange(e) {
      handleDateChange(e);
      //handleFilterChange(e);
    },
    startDate: shortLeaveStartDate,
    endDate: shortLeaveEndDate,
    selectsRange: true,
    showMonthYearPicker: true
    // minDate={
    //   permissionSettingData?.leaveSettingsPermission?.leavePermissions == "false"
    //     ? datepickerPermissionForPast[0]
    //     : organisationBilling?.planName == "free" || organisationBilling?.planStatus == "stopped"
    //     ? datePickerMinDate[0]
    //     : ""
    // }
  }))));
}
var ViewShortLeaveModal = function ViewShortLeaveModal(props) {
  var _userShortLeaveHistor, _userShortLeaveHistor2, _userShortLeaveHistor3, _userShortLeaveHistor4;
  var viewShortLeaveShow = props.viewShortLeaveShow,
    handleViewShortLeaveClose = props.handleViewShortLeaveClose,
    getUserShortLeaveHistory = props.getUserShortLeaveHistory,
    userShortLeaveHistoryData = props.userShortLeaveHistoryData,
    userShortLeaveHistoryError = props.userShortLeaveHistoryError,
    userShortLeaveHistoryLoading = props.userShortLeaveHistoryLoading,
    organisationId = props.organisationId,
    organisationTimezone = props.organisationTimezone,
    userShortLeaveHistoryFetchMore = props.userShortLeaveHistoryFetchMore,
    shortLeaveStartDate = props.shortLeaveStartDate,
    shortLeaveEndDate = props.shortLeaveEndDate;
  if (!viewShortLeaveShow) {
    return null;
  }
  var _viewShortLeaveShow$u = viewShortLeaveShow === null || viewShortLeaveShow === void 0 ? void 0 : viewShortLeaveShow.user,
    userId = _viewShortLeaveShow$u.userId,
    displayName = _viewShortLeaveShow$u.displayName;

  //   const USER_LEAVE_LIMIT = 15;
  // let leave_offsets = 0;
  var date = "".concat(moment(Number(shortLeaveStartDate)).format("MMM,YYYY"));
  if (shortLeaveEndDate != null) {
    date = "".concat(moment(Number(shortLeaveStartDate)).format("MMM,YYYY"), "-").concat(moment(Number(shortLeaveEndDate)).format("MMM,YYYY"));
  }
  useEffect(function () {
    if (viewShortLeaveShow && userId) {
      getUserShortLeaveHistory({
        variables: {
          organisationId: organisationId,
          userId: userId,
          timeZone: organisationTimezone,
          limit: USER_LEAVE_LIMIT,
          offset: 0,
          startTime: Number(shortLeaveStartDate),
          endTime: shortLeaveEndDate ? Number(shortLeaveEndDate) : Number(shortLeaveStartDate)
        }
      });
    }
  }, [viewShortLeaveShow]);
  var _React$useState51 = React.useState(false),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    isAllLoadedShortLeaveModal = _React$useState52[0],
    setIsAllLoadedShortLeaveModal = _React$useState52[1];
  var _React$useState53 = React.useState(false),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    isLoadingMoreShortLeaveModal = _React$useState54[0],
    setIsLoadingMoreShortLeaveModal = _React$useState54[1];
  var _React$useState55 = React.useState(false),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    isLoadMoreButtonShortLeaveModal = _React$useState56[0],
    setIsLoadMoreButtonShortLeaveModal = _React$useState56[1];
  var handleLoadMore = function handleLoadMore() {
    if (userShortLeaveHistoryLoading) return;
    setIsLoadingMore(true);
    leave_offsets = leave_offsets + 1;
    userShortLeaveHistoryFetchMore({
      variables: {
        offset: leave_offsets * USER_LEAVE_LIMIT
      },
      updateQuery: function updateQuery(prev, _ref16) {
        var _fetchMoreResult$user3, _fetchMoreResult$user4;
        var fetchMoreResult = _ref16.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$user3 = fetchMoreResult.userShortLeaveHistory) === null || _fetchMoreResult$user3 === void 0 ? void 0 : _fetchMoreResult$user3.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$user4 = fetchMoreResult.userShortLeaveHistory) === null || _fetchMoreResult$user4 === void 0 ? void 0 : _fetchMoreResult$user4.length) < LIMIT && !isAllLoadedShortLeaveModal) {
          setIsAllLoadedShortLeaveModal(true);
        }
        setIsLoadingMoreShortLeaveModal(false);
        var NewFilterData = [];
        fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.userShortLeaveHistory.forEach(function (newLeave) {
          var found = prev === null || prev === void 0 ? void 0 : prev.userShortLeaveHistory.find(function (item) {
            return item.leaveId === newLeave.leaveId;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newLeave);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          userShortLeaveHistory: [].concat(_toConsumableArray(prev.userShortLeaveHistory), NewFilterData)
        });
      }
    });
  };
  if ((userShortLeaveHistoryData === null || userShortLeaveHistoryData === void 0 ? void 0 : (_userShortLeaveHistor = userShortLeaveHistoryData.userShortLeaveHistory) === null || _userShortLeaveHistor === void 0 ? void 0 : _userShortLeaveHistor.length) !== 0 && (userShortLeaveHistoryData === null || userShortLeaveHistoryData === void 0 ? void 0 : (_userShortLeaveHistor2 = userShortLeaveHistoryData.userShortLeaveHistory) === null || _userShortLeaveHistor2 === void 0 ? void 0 : _userShortLeaveHistor2.length) < USER_LEAVE_LIMIT && !isAllLoadedShortLeaveModal) {
    setIsAllLoadedShortLeaveModal(true);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: viewShortLeaveShow,
    onHide: handleViewShortLeaveClose,
    animation: false,
    size: "lg",
    className: "view-user-leave-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "view-user-leave-modal-header-title"
  }, "".concat(displayName, " Short Leave History (").concat(date, ")"))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    "class": "view-leave-history-content-new"
  }, userShortLeaveHistoryLoading ? /*#__PURE__*/React.createElement(Loader, null) : userShortLeaveHistoryError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : userShortLeaveHistoryData !== null && userShortLeaveHistoryData !== void 0 && (_userShortLeaveHistor3 = userShortLeaveHistoryData.userShortLeaveHistory) !== null && _userShortLeaveHistor3 !== void 0 && _userShortLeaveHistor3.length ? /*#__PURE__*/React.createElement("table", {
    className: "view-user-leave-history-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Date"), /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Duration"), /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Applied On"), /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Notes"), /*#__PURE__*/React.createElement("th", {
    className: "project-report-react-table-thead"
  }, "Status"))), /*#__PURE__*/React.createElement("tbody", null, userShortLeaveHistoryData === null || userShortLeaveHistoryData === void 0 ? void 0 : userShortLeaveHistoryData.userShortLeaveHistory.map(function (row, i) {
    var permissionId = row.permissionId,
      leaveStartDateFormat = row.leaveStartDateFormat,
      permissionStartTime = row.permissionStartTime,
      permissionEndTime = row.permissionEndTime,
      appliedAt = row.appliedAt,
      permissionRemark = row.permissionRemark,
      appliedStatus = row.appliedStatus,
      totalPermissionHour = row.totalPermissionHour,
      dateDetails = row.dateDetails;

    //let leaveTypeValue = leaveType.replace(/-/g, " ");

    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, leaveStartDateFormat, " ", /*#__PURE__*/React.createElement("span", {
      className: "short-leave-history-time"
    }, "(", moment.unix(permissionStartTime / 1000).format("hh:mm A"), " -", " ", moment.unix(permissionEndTime / 1000).format("hh:mm A"), ")")), /*#__PURE__*/React.createElement("td", null, totalPermissionHour, " "), /*#__PURE__*/React.createElement("td", null, moment.unix(appliedAt / 1000).format("DD MMM, yyyy")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, decodeHtmlEntities(permissionRemark))
    }, /*#__PURE__*/React.createElement("div", {
      className: "view-user-leave-history-table-leave-reason"
    }, decodeHtmlEntities(permissionRemark)))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "view-user-leave-history-table-status view-user-leave-history-table-".concat(appliedStatus, "-status")
    }, appliedStatus)));
  }))) : "No data found !!!", userShortLeaveHistoryData !== null && userShortLeaveHistoryData !== void 0 && (_userShortLeaveHistor4 = userShortLeaveHistoryData.userShortLeaveHistory) !== null && _userShortLeaveHistor4 !== void 0 && _userShortLeaveHistor4.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoadedShortLeaveModal ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMoreShortLeaveModal && !isLoadMoreButtonShortLeaveModal ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "You have seen all the short leaves")) : null)));
};
export default LeaveHistory;